<template>
  <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <NavbarComponent />

    <div class="mx-8 my-6 ">
      <div class="hr-container space-x-5 mb-6 ">
        <div class="flex justify-between">
          <div class="space-y-3">
            <p class="font-semibold text-bodyText text-[20px] space-x-3">Talents</p>
            <p class="text-bodyText text-[14px]">Access profiles, roles, and performance insights to keep everyone aligned.</p>            
          </div>
        </div>

      </div>
      <ErrorMessage
        v-if="showError"
        :message="errorMessage"
        :duration="5000"
        @hidden="
          showError = false;
          errorMessage = '';
        "
      />
        <div class="flex ml-auto justify-between mb-8 space-x-6 py-1 text-[14px] rounded-[6px] items-center">
          <p class="flex items-center cursor-pointer gap-2 rounded-[6px] bg-[#FFFFFF] bg-[14px] px-4 py-1 border border-grayLight">
            <img src="@/assets/projects/sort.svg" alt="Icon" class="">            
            Filters
          </p>
        </div>
        <!-- <pre>{{ talents }}</pre> -->
          <TalentTable />

    </div>

  </div>

</template>



<script>
import apiClient from '@/axios';
import NavbarComponent from '../NavbarComponent.vue';
import TalentTable from './TalentTable.vue';
import ErrorMessage from "../messages/ErrorMessage.vue";

export default {
  name: 'TalentManagementComponent',
  components: {
    NavbarComponent,
    TalentTable,
    ErrorMessage
  },
  data() {
    return {
      viewMode: 'list',
      talents: [], // For admin
      managedProjects: [], // For managers to store projects and their talents (members)
      loading: true,
      showEditModal: false,
      selectedTalent: {
        first_name: '',
        last_name: '',
        email: ''
      },
      availableSkills: [],
      selectedSkill: '',
      showError: false,
      errorMessage: "",
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    }
  },
  methods: {
    // Helper method to check if a project has valid members
    hasValidMembers(members) {
      return members && members.some(member => member.talent_user_id !== null);
    },
    setViewMode(mode) {
      this.viewMode = mode;
    },
    async fetchTalents() {
      try {
        let response;

        if (this.isAdmin) {
          // Fetch all talents for Admin
          response = await apiClient.get('/web/talents');
          this.talents = response.data.data;
        } else if (this.isManager) {
          // Fetch projects and talents managed by the Manager
          response = await apiClient.get('/web/manager/me');
          this.managedProjects = response.data.data.projects; // Projects that manager is responsible for
        }
      } catch (error) {
        console.error('Error fetching talents or projects:', error);
      } finally {
        this.loading = false;
      }
    },
    created() {
        this.managedProjects = this.projects; // Show all projects initially
      },
    goToReports(project_id, userId) {
      this.$router.push({ name: 'ProgressReports', params: { project_id, userId } });
    },
    openEditModal(talent) {
      this.selectedTalent = { ...talent }; // Clone the talent data
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    async submitEditModal(updatedTalent) {
      try {
        await apiClient.put(`/web/talents/${updatedTalent.user_id}`, {
          user: updatedTalent,
          skill_id: this.selectedSkill
        });
        this.fetchTalents(); // Refresh the talents list
      } catch (error) {
        console.error('Error updating talent:', error);
      } finally {
        this.closeEditModal();
      }
    },
    handleError(message) {
      this.showError = true;
      this.errorMessage = message;

      setTimeout(() => {
        this.showError = false;
        this.errorMessage = "";
      }, 5000);
    },
  },
  created() {
    if(!this.isAdmin && !this.isManager){
      const errorMessage = "Only managers have access to this page, you need to have a manager profile to access this page.";
      this.handleError(errorMessage);
      setTimeout(() => {
        this.$router.push("/explore");
      }, 3000);
      return;
    }
    this.fetchTalents();
  }
};
</script>

<style scoped>
/* Add modern styles */
.container {
  max-width: 1120px;
  margin: auto;
}

h1, h2 {
  color: #333;
}

table {
  border-collapse: collapse;
}

th, td {
  padding: 1rem;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

button {
  font-weight: 500;
}
</style>
